import dayjs from 'dayjs';
import { z } from 'zod';

import {
  digitValidation,
  lowercaseValidation,
  minLengthValidation,
  specialCharValidation,
  uppercaseValidation
} from './rules.ts';

export const VALIDATE = {
  PASSWORD: z
    .string()
    .and(uppercaseValidation)
    .and(minLengthValidation)
    .and(lowercaseValidation)
    .and(digitValidation)
    .and(specialCharValidation),
  MINIMAL_CONTRACT_DURATION: z.coerce
    .number({ message: 'Enter the number of weeks' })
    .min(1, { message: 'The minimum number of weeks is 1' })
    .max(48, { message: 'The maximum number of weeks is 48' }),
  EMAIL: z.string().email(),
  OTP_CODE: z.string().min(4).max(4),
  PHONE_NUMBER: z.string().min(5, { message: 'Phone number is required' }),
  ARRAY_OF_STRING: z.array(z.string()).min(1, { message: 'Add some options' }),
  REQUIRED: z.string().trim().min(2, { message: 'Field is required' }),
  DATE_REQUIRED: z.date({ message: 'Date is required' }),
  YEARS_OLD: z.string().refine(
    (dateString) => {
      const birthDate = dayjs(dateString);
      const today = dayjs();
      const age = today.diff(birthDate, 'year');
      return age >= 18;
    },
    {
      message: 'You must be at least 18 years old'
    }
  )
};
